import decode from 'jwt-decode';

import { WebAuth } from 'auth0-js';

import TokenStore from '../stores/TokenStore';
import ProfileStore from '../stores/ProfileStore';

import { AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_ZENDESK_CLIENT_ID } from '../config/auth0-config';

const auth0 = new WebAuth({
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID,
});

export function openZenDeskWidget() {
  window.zE(() => {
    window.zE.activate({ hideOnClose: true });
  });
}

export function showZenDeskOverlay() {
  window.zE(() => {
    window.zE.show();
  });
}

export function hideZenDeskOverlay() {
  window.zE(() => {
    window.zE.hide();
  });
}


function updateZendeskWidgetProfile() {
  window.zE(() => {
    const profile = ProfileStore.getState();
    if (profile) {
      window.zE.identify({
        name: profile.name,
        email: profile.email,
      });
    }
  });
}

export function initializeZendesk() {
  window.zESettings = {
    webWidget: {
      zIndex: 9999999,
    },
  };

  window.zEmbed || (function zEmbedInit() {
    const queue = [];

    window.zEmbed = function zEmbed(...args) {
      queue.push(args);
    };
    window.zE = window.zE || window.zEmbed;
    document.zendeskHost = 'bluelabs.zendesk.com';
    document.zEQueue = queue;
  }());

  hideZenDeskOverlay();

  ProfileStore.addListener(updateZendeskWidgetProfile);
}

export function openZenDeskWindow() {
  const params = {
    id_token: TokenStore.getToken(), // eslint-disable-line camelcase
    api_type: 'app',
    target: AUTH0_ZENDESK_CLIENT_ID,
    scope: 'openid name email zendesk_url',
  };

  const newWindow = window.open('', '_blank');
  newWindow.blur();

  auth0.getDelegationToken(params, (err, result) => {
    if (err) {
      console.error(err);
    } else {
      const zenDeskUrl = decode(result.id_token).zendesk_url;
      const redirectUrl = `${zenDeskUrl}&return_to=https://bluelabs.zendesk.com/hc/en-us`;
      newWindow.location.href = redirectUrl;
    }
  });
}
